import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RelatorioService {

  constructor(private httpClient: HttpClient) { }

  listaClienteDireto(ignore = []) {
    return this.httpClient.get<any>(environment.wsUrl + 'unidade/listaClienteDireto',
    {
      params: { ignore: ignore },
    }).toPromise();
  }

  listaUnidade(ignore = []) {
    return this.httpClient.get<any>(environment.wsUrl + 'unidade/listaUnidadeNomeFantasia',
    {
      params: { ignore: ignore },
    }).pipe().toPromise();
  }

  gerarRelatorioProducao(data, ignore = []) {
    return this.httpClient.post<any>(environment.wsUrl + 'relatorio/getRelatorioProducao', data,
      {
        params: { ignore: ignore },
      }).toPromise();
  }

  gerarRelatorio(data, ignore = ['loading']) {
    return this.httpClient.post<any>(environment.wsUrl + 'relatorio/gerarRelatorio', data,
    {
      params: { ignore: ignore },
    }).toPromise();
  }

  gerarRelatorioXls(data, ignore = ['content-type']) {
    return this.httpClient.post(environment.wsUrl + 'relatorio/gerarRelatorioXls', data,
    {
      params: { ignore: ignore }, responseType: 'blob'
    }).toPromise();
  }

}
